/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Portuguese (Portugal)
export default {
    'fabric.atlassianSwitcher.switchTo': 'Mudar para',
    'fabric.atlassianSwitcher.switchToTooltip': 'Mudar para...',
    'fabric.atlassianSwitcher.recent': 'Recente',
    'fabric.atlassianSwitcher.more': 'Mais',
    'fabric.atlassianSwitcher.try': 'Experimente',
    'fabric.atlassianSwitcher.manageList': 'Gerir lista',
    'fabric.atlassianSwitcher.jiraProject': 'Projeto do JIRA',
    'fabric.atlassianSwitcher.confluenceSpace': 'Espaço do Confluence',
    'fabric.atlassianSwitcher.people': 'Pessoas',
    'fabric.atlassianSwitcher.administration': 'Administração',
    'fabric.atlassianSwitcher.discoverMore': 'Descobrir mais',
    'fabric.atlassianSwitcher.errorHeading': 'Ocorreu um erro',
    'fabric.atlassianSwitcher.errorText': 'Temos conhecimento destes erros, mas contacte-nos se atualizar a página não solucionar o problema.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Um problema e várias pessoas a tentar corrigi-lo.',
    'fabric.atlassianSwitcher.expand': 'Expandir',
};
//# sourceMappingURL=pt_PT.js.map